(function () {
  const loader = document.getElementById('VaahiniLuxuryLoader');
  if (!loader) return;

  const SAFETY_MAX_MS = 15000;

  let isVisible = false;
  let pinned = 0;
  let cssLoaded = false;
  let cssLoading = null;

  const applyVisible = (visible) => {
    isVisible = visible;
    loader.classList.toggle('is-active', visible);
    loader.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };

  const ensureLoaderCss = () => {
    if (cssLoaded) return Promise.resolve();
    if (cssLoading) return cssLoading;

    const cssUrl = loader.dataset.cssUrl;
    if (!cssUrl) {
      cssLoaded = true;
      return Promise.resolve();
    }

    cssLoading = new Promise((resolve) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssUrl;
      link.onload = () => {
        cssLoaded = true;
        resolve();
      };
      link.onerror = () => {
        cssLoaded = true;
        resolve();
      };
      document.head.appendChild(link);
    });

    return cssLoading;
  };

  const hideLoader = () => {
    if (pinned > 0) return;
    applyVisible(false);
  };

  const showLoader = async (options = {}) => {
    if (options.pin) pinned += 1;

    await ensureLoaderCss();

    if (options.immediate) {
      applyVisible(true);
      return;
    }

    applyVisible(true);
  };

  const releaseLoader = () => {
    pinned = Math.max(0, pinned - 1);
    if (pinned === 0) hideLoader();
  };

  window.VaahiniLoader = {
    show: showLoader,
    hide: hideLoader,
    release: releaseLoader,
    get isVisible() {
      return isVisible;
    },
  };

  applyVisible(false);

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) hideLoader();
  });

  setTimeout(() => {
    pinned = 0;
    hideLoader();
  }, SAFETY_MAX_MS);
})();
